
export const TRANSLATIONS: any = {
  provide: 'translations',
  useValue: {
    "en-GB": {
      "plcview": {
        "red": "Data read from {0}"
      },
      "sqlview": {
        "queried": "Data read from {0}"
      }
    },
    "de-DE": {
      "plcview": {
        "red": "Gelesene Daten von {0}"
      },
      "sqlview": {
        "queried": "Gelesene Daten von {0}"
      }
    }
  }
};